/**
 * Fubo Marketing Design System
 * Central export for all design tokens
 *
 * Usage:
 * import { colors, spacing, typography, breakpoints } from 'src/constants/marketing-ds'
 *
 * Or import specific tokens:
 * import { colors } from 'src/constants/marketing-ds'
 * import { spacing, mediaQuery } from 'src/constants/marketing-ds'
 */

// Export all design tokens
export { colors } from './colors'
export { spacing } from './spacing'
export {
  fontFamily,
  fontWeight,
  fontSizes,
  lineHeight,
  body,
  heading,
  typographyMixin,
} from './typography'
export {
  borderRadius,
  borderWidth,
  breakpoints,
  mediaQuery,
  fadeGradients,
  maxWidth,
} from './layout'

// Default export with all tokens grouped
export default {
  colors: require('./colors'),
  spacing: require('./spacing'),
  typography: require('./typography'),
  layout: require('./layout'),
}
